import { FC, useCallback, useState } from 'react'
import { Button } from '@cargomart/ui'
import { ModalSimple } from 'components/ModalSimple'
import { useIsMobile } from 'hooks/media'
import { formattedCoordinates } from 'modules/order/helpers'

import SearchMap from '../../SearchMap'
import { OrderCreateFormNoDadataRouteItemProps } from './types'

import s from './OrderCreateFormNoDadataRouteItem.module.less'

export const OrderCreateFormNoDadataRouteItem: FC<OrderCreateFormNoDadataRouteItemProps> = (props) => {
  const { id, handleCloseModal, coords, setCoords, address, setAddress, handleAccept } = props
  const [currentAddress, seCurrentAddress] = useState<string>(address)
  const [currentCoords, seCurrentCoords] = useState<number[]>(coords)
  const [zoom, setZoom] = useState(10)

  const isMobile = useIsMobile()

  const onClose = useCallback(() => {
    setZoom(10)
    handleCloseModal()
  }, [handleCloseModal])

  const handleSelect = useCallback(() => {
    handleAccept({ address: currentAddress, coords: currentCoords })
    setAddress(currentAddress)
    setCoords(currentCoords)
  }, [currentAddress, currentCoords, handleAccept, setAddress, setCoords])

  const handleBoundsChange = useCallback(({ coords, address }: { address: string; coords: CoordinateType }) => {
    seCurrentAddress(address)
    seCurrentCoords(coords)
  }, [])

  return (
    <ModalSimple
      bodyClassName="flex flex-col"
      id={id}
      onClose={onClose}
      size="nm"
      mobileModalFooter={
        <Button className="block w-full" onClick={handleSelect} size="lg" variant="solid">
          Применить
        </Button>
      }
      modalFooter={
        <div className="ml-auto flex gap-x-2">
          <Button className="ml-auto" onClick={onClose} size="lg" variant="outline">
            Отменить
          </Button>
          <Button onClick={handleSelect} size="lg" variant="solid">
            Применить
          </Button>
        </div>
      }
      title={
        <>
          Выбор адреса с карты
          {!isMobile && (
            <div className={s.detailInfo}>
              <div className={s.address}>{currentAddress}</div>
              <div className={s.coords}>{formattedCoordinates(currentCoords)}</div>
            </div>
          )}
        </>
      }
    >
      <>
        {isMobile && (
          <>
            <div className={s.address}>{currentAddress}</div>
            <div className={s.coords}>{formattedCoordinates(currentCoords)}</div>
          </>
        )}
        <SearchMap center={currentCoords} height={425} onBoundsChange={handleBoundsChange} zoom={zoom} />
      </>
    </ModalSimple>
  )
}
